import React from "react";

const LearnEveryDayBottomBGElement = () => {
  return (
    <svg
      width="62"
      height="72"
      viewBox="0 0 62 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6476_35651)">
        <path
          d="M0 75C0 88.8071 11.1929 100 25 100C38.8071 100 50 88.8071 50 75V50C50 22.3858 27.6142 0 0 0V75Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M12 87C12 100.807 23.1929 112 37 112C50.8071 112 62 100.807 62 87V62C62 34.3858 39.6142 12 12 12V87Z"
          fill="white"
          fillOpacity="0.04"
        />
      </g>
      <defs>
        <clipPath id="clip0_6476_35651">
          <rect width="62" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LearnEveryDayBottomBGElement;
